<template>
  <TableBodyRow
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr cursor_hover"
  >
    <TableBodyCell
      v-for="ii in [
        { val: item.stack, id: 'stack' },
        { val: numFixed(item.chip_percentage, 3), id: 'chip_percentage' },
        { val: numFixedUnit(item.ev, 'dollar_ev'), id: 'ev' },
        { val: numFixed(item.ev_percentage, 3), id: 'ev_percentage' },
      ]"
      :key="ii.id"
      :data-tst="`${tstPrefix}_cell_${ii.id}`"
      :thKey="ii.id"
    >
      <div
        class="truncate"
        :title="ii.val"
      >
        {{ ii.val }}
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'IcmCalculatorResultTableRow',
  components: {
    TableBodyRow,
    TableBodyCell,
  },
  mixins: [format_mix],
  props: {
    item: Object,
    thead: Object,
    index: Number,
    tstPrefix: String,
  },
}
</script>
